/** Read and JSON-parse the persisted `user` record from localStorage, or `null` if absent/invalid. */
export const getUser = () => {
  let user = localStorage.getItem('user');
  if (!user) {
    return null;
  }
  if (typeof user === 'string') {
    try {
      user = user ? JSON.parse(user) : null;
    } catch (error) {
      user = null;
    }
  }
  return user;
};

/**
 * Initial state factory for the "userauth" Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. `user` is seeded from
 * localStorage so a page reload doesn't lose the logged-in profile, and
 * `authStatus` is derived from whether that stored user exists. The
 * remaining fields (`userPhone` through `zipCode`) hold values collected
 * across the multi-step SMS signup/onboarding flow before the account
 * exists in `user`.
 */
export default () => {
  const user = getUser();
  return {
    user: user,
    error: null,
    showSmsCodeInput: false,
    userPhone: '',
    userName: '',
    firstName: '',
    lastName: '',
    birthDate: '',
    referralCode: '',
    county: '',
    streetAddress: '',
    streetAddress2: '',
    city: '',
    addressState: '',
    zipCode: '',
    authErrorNotification: null,
    authStatus: !!user,
  };
};
